export const graphe = 'graphe';
export const graphe_automatique = 'graphe_automatique';
export const visualisation = 'visualisation';
